import { ChangeEvent } from 'react'

import { Button, Card, Input } from '..'

export type TChangeProfileInfo = {
  readonly inputType: 'number' | 'textarea' | 'text' | 'tel' | 'password' | 'date'
  readonly value: string
  readonly onChangeValue: (value: string) => void
  readonly error?: string
  readonly buttonLabel: string
  readonly isButtonDisabled?: boolean
  readonly inputLabel: string
  readonly inputCaption: string
}

export default function ChangeProfileInfo({
  inputType,
  value,
  onChangeValue,
  error,
  buttonLabel,
  isButtonDisabled = false,
  inputLabel,
  inputCaption,
}: TChangeProfileInfo) {
  const handleChangeInput = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChangeValue(e.target.value)
  }

  return (
    <Card>
      <div className='flex flex-col gap-5'>
        <Input
          type={inputType}
          caption={inputCaption}
          label={inputLabel}
          value={value}
          onChange={handleChangeInput}
          error={error}
        />
        <Button
          type='submit'
          variant='contained'
          color='primary'
          disabled={isButtonDisabled}
          aria-label={buttonLabel}
        >
          {buttonLabel}
        </Button>
      </div>
    </Card>
  )
}
